import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-godoy-dark border-t border-godoy-gold/20">
      <div className="w-full px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8">
                <img
                  src="https://pub-bc092def332d4fb180f02b510802da8e.r2.dev/LogoGP.png"
                  alt="GodoyProd"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-serif text-lg font-semibold text-godoy-cream tracking-[0.12em] uppercase">
                GodoyProd
              </span>
            </div>
            <p className="text-godoy-lightgray text-sm leading-relaxed">
              A maior biblioteca de partituras gospel do Brasil.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="font-serif text-godoy-gold text-sm font-semibold tracking-wide uppercase">
              Navegação
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors"
              >
                Início
              </Link>
              <Link
                to="/biblioteca"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors"
              >
                Biblioteca
              </Link>
              <Link
                to="/cursos"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors"
              >
                Cursos
              </Link>
              <Link
                to="/sobre"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors"
              >
                Sobre
              </Link>
              <Link
                to="/contato"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors"
              >
                Contato
              </Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-serif text-godoy-gold text-sm font-semibold tracking-wide uppercase">
              Contato
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="mailto:contato@godoyprod.com"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors flex items-center gap-2"
              >
                <i className="ri-mail-line" />
                contato@godoyprod.com
              </a>
              <a
                href="https://wa.me/5515991811212"
                target="_blank"
                rel="noopener noreferrer"
                className="text-godoy-lightgray text-sm hover:text-godoy-gold transition-colors flex items-center gap-2"
              >
                <i className="ri-whatsapp-line" />
                (15) 9 9181-1212
              </a>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-serif text-godoy-gold text-sm font-semibold tracking-wide uppercase">
              Redes Sociais
            </h4>
            <div className="flex gap-3">
              <a
                href="https://open.spotify.com/user/eugoodoy?si=8d3a4aea30714493"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
              >
                <i className="ri-spotify-fill text-lg" />
              </a>
              <a
                href="https://www.instagram.com/eugoodoy"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
              >
                <i className="ri-instagram-fill text-lg" />
              </a>
              <a
                href="https://www.youtube.com/@GodoyProd"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
              >
                <i className="ri-youtube-fill text-lg" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-godoy-gray/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-godoy-lightgray text-xs">
            © 2026 GodoyProd. Todos os direitos reservados.
          </p>
          <p className="text-godoy-lightgray text-xs">
            Developed by Matheus Godoy
          </p>
        </div>
      </div>
    </footer>
  );
}